import { VendorDeleteAdapter } from '../../../../adapter';

export default async function VendorDeleteUseCase(event) {
    const { id } = event;

    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/vendor/delete';

    const payload = {
        data: {
            vendorData: {
                id: id,
            },
            signature: ''
        }
    };

    const result = await VendorDeleteAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
